<template>
  <div class="tab-pane active">
    <ul class="catalog__tab-list">
      <filter-block
        title="Контент для карточки товара"
        :type="type"
        filter-key="card"
        :loading="loading" />
      <filter-block
        title="Логистическая информация"
        :type="type"
        filter-key="logistic"
        :loading="loading" />
    </ul>
  </div>
</template>

<script>
import { SET_FILTER_DATA } from '@/store/actions/search'
import FilterBlock from '@/components/FilterBlock'
import { mapGetters } from 'vuex'

export default {
  name: 'filter-type-static',
  components: {
    FilterBlock
  },
  data: () => ({
    loading: true,
  }),
  created () {
    if (this.isEmptyData(this.type)) {
      this.$api.filter.static().then((response) => {
        const { data } = response
        this.$store.dispatch(SET_FILTER_DATA, { data, type: this.type }).then(() => {
          this.loading = false
        })
      })
    } else {
      this.loading = false
    }
  },
  computed: {
    type () {
      return 'static'
    },
    ...mapGetters(['isEmptyData'])
  }
}
</script>
